var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_51639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0649 28.935L25.9649 23.85C27.6104 21.7537 28.5033 19.165 28.4999 16.5C28.4999 14.1266 27.7962 11.8066 26.4776 9.83316C25.159 7.85977 23.2849 6.3217 21.0921 5.41345C18.8994 4.5052 16.4866 4.26756 14.1589 4.73058C11.8311 5.1936 9.69289 6.33649 8.01466 8.01472C6.33643 9.69295 5.19354 11.8312 4.73052 14.1589C4.2675 16.4867 4.50514 18.8995 5.41339 21.0922C6.32164 23.2849 7.85971 25.1591 9.8331 26.4776C11.8065 27.7962 14.1266 28.5 16.4999 28.5C19.1649 28.5033 21.7536 27.6105 23.8499 25.965L28.9349 31.065C29.0744 31.2056 29.2403 31.3172 29.4231 31.3933C29.6059 31.4695 29.8019 31.5087 29.9999 31.5087C30.198 31.5087 30.394 31.4695 30.5768 31.3933C30.7596 31.3172 30.9255 31.2056 31.0649 31.065C31.2055 30.9256 31.3171 30.7597 31.3933 30.5769C31.4694 30.3941 31.5086 30.198 31.5086 30C31.5086 29.802 31.4694 29.6059 31.3933 29.4231C31.3171 29.2404 31.2055 29.0745 31.0649 28.935ZM7.49994 16.5C7.49994 14.72 8.02779 12.9799 9.01672 11.4999C10.0057 10.0198 11.4113 8.86628 13.0558 8.18509C14.7003 7.5039 16.5099 7.32567 18.2558 7.67294C20.0016 8.0202 21.6052 8.87737 22.8639 10.136C24.1226 11.3947 24.9797 12.9984 25.327 14.7442C25.6743 16.49 25.496 18.2996 24.8149 19.9442C24.1337 21.5887 22.9801 22.9943 21.5001 23.9832C20.02 24.9722 18.28 25.5 16.4999 25.5C14.113 25.5 11.8238 24.5518 10.136 22.864C8.44816 21.1761 7.49994 18.887 7.49994 16.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_51639",
    x: 0.499939,
    y: 4.5,
    width: 35.0087,
    height: 35.0087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_51639"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_51639",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.705cd3fa84f2c8129a5379be4ba06e71.svg";
export { ForwardRef as ReactComponent };